import { render, staticRenderFns } from "./IconCamera.vue?vue&type=template&id=0d5b35c3&scoped=true&"
import script from "./IconCamera.vue?vue&type=script&lang=js&"
export * from "./IconCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b35c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5b35c3')) {
      api.createRecord('0d5b35c3', component.options)
    } else {
      api.reload('0d5b35c3', component.options)
    }
    module.hot.accept("./IconCamera.vue?vue&type=template&id=0d5b35c3&scoped=true&", function () {
      api.rerender('0d5b35c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconCamera.vue"
export default component.exports